//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ClientBase } from './client-base';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class HealthcheckClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Endpoint for checking if Vitech service is alive.
     * @return OK
     */
    alive(): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/healthcheck/alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAlive(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAlive(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processAlive(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * An endpoint that returns a cookie for authentication.
     * @return OK
     */
    groupexists(): Observable<FlagsApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/healthcheck/groupexists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGroupexists(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGroupexists(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBoolean>;
        }));
    }

    protected processGroupexists(response: HttpResponseBase): Observable<FlagsApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all forms information for a policy.
     * @param selectedState (optional) The selected state from UI.
     * @return OK
     */
    allForms(selectedState?: string | undefined): Observable<ApiResponseOfAllFormsResponse> {
        let url_ = this.baseUrl + "/v1/forms/allForms?";
        if (selectedState === null)
            throw new Error("The parameter 'selectedState' cannot be null.");
        else if (selectedState !== undefined)
            url_ += "selectedState=" + encodeURIComponent("" + selectedState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllForms(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllForms(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfAllFormsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfAllFormsResponse>;
        }));
    }

    protected processAllForms(response: HttpResponseBase): Observable<ApiResponseOfAllFormsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfAllFormsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets overview information for a policy.
     * @param body (optional) EOI Application filters to retrieve EOI Application details.
     * @return OK
     */
    eoireport(body?: EOIApplicationsRequest | undefined): Observable<ApiResponseOfEOIApplicationsReponse> {
        let url_ = this.baseUrl + "/v1/forms/eoireport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEoireport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEoireport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfEOIApplicationsReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfEOIApplicationsReponse>;
        }));
    }

    protected processEoireport(response: HttpResponseBase): Observable<ApiResponseOfEOIApplicationsReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfEOIApplicationsReponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets overview information for a policy.
     * @param body (optional) request filters to retrieve scheduleA letters.
     * @return OK
     */
    scheduleALetter(body?: ScheduleALetterSearchRequest | undefined): Observable<ApiResponseOfScheduleALetterSearchReponse> {
        let url_ = this.baseUrl + "/v1/forms/scheduleALetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processScheduleALetter(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processScheduleALetter(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfScheduleALetterSearchReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfScheduleALetterSearchReponse>;
        }));
    }

    protected processScheduleALetter(response: HttpResponseBase): Observable<ApiResponseOfScheduleALetterSearchReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfScheduleALetterSearchReponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Request ScheduleA letters.
     * @param body (optional) The ScheduleA letter request.
     * @return OK
     */
    requestScheduleALetter(body?: ScheduleAEmailServiceInput | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/forms/requestScheduleALetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestScheduleALetter(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestScheduleALetter(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processRequestScheduleALetter(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillingsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for billing that on a policy that match the provided filter criteria.
     * @param body (optional) The billing search request.
     * @return OK
     */
    search(body?: BillingSearchRequest | undefined): Observable<FlagsApiResponseOfBillingSearchResponse> {
        let url_ = this.baseUrl + "/v1/billings/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfBillingSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfBillingSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlagsApiResponseOfBillingSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfBillingSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClaimsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets Claim Loss Units.
     * @return OK
     */
    claimlossunit(): Observable<ApiResponseOfCluSearchResponse> {
        let url_ = this.baseUrl + "/v1/claims/claimlossunit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClaimlossunit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClaimlossunit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCluSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCluSearchResponse>;
        }));
    }

    protected processClaimlossunit(response: HttpResponseBase): Observable<ApiResponseOfCluSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCluSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContactClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets Sym employee info.
     * @param userName (optional) The username to retrieve info.
     * @return OK
     */
    symcontacts(userName?: string | undefined): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        let url_ = this.baseUrl + "/v1/Contact/symcontacts?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSymcontacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSymcontacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
        }));
    }

    protected processSymcontacts(response: HttpResponseBase): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfSymetraEmployeeContactResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Sym employee info.
     * @param userName (optional) The username to retrieve info.
     * @return OK
     */
    symcontactslocal(userName?: string | undefined): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        let url_ = this.baseUrl + "/v1/Contact/symcontactslocal?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSymcontactslocal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSymcontactslocal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfSymetraEmployeeContactResponse>;
        }));
    }

    protected processSymcontactslocal(response: HttpResponseBase): Observable<ApiResponseOfSymetraEmployeeContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfSymetraEmployeeContactResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PolicyClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets coverage information for a policy.
     * @return OK
     */
    coverage(): Observable<ApiResponseOfPolicyCoveragesResponse> {
        let url_ = this.baseUrl + "/v1/policy/coverage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCoverage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCoverage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPolicyCoveragesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPolicyCoveragesResponse>;
        }));
    }

    protected processCoverage(response: HttpResponseBase): Observable<ApiResponseOfPolicyCoveragesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPolicyCoveragesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets overview information for a policy.
     * @return OK
     */
    overview(): Observable<FlagsApiResponseOfPolicyOverviewResponse> {
        let url_ = this.baseUrl + "/v1/policy/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processOverview(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processOverview(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfPolicyOverviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfPolicyOverviewResponse>;
        }));
    }

    protected processOverview(response: HttpResponseBase): Observable<FlagsApiResponseOfPolicyOverviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfPolicyOverviewResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets tokens representing the input policy ids.
     * @param x_policy_id (optional) The policy id which should be represented as a token.
     * @return OK
     */
    tokens(x_policy_id?: string[] | undefined): Observable<ApiResponseOfDictionaryOfString_String> {
        let url_ = this.baseUrl + "/v1/policy/tokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-policy-id": x_policy_id !== undefined && x_policy_id !== null ? "" + x_policy_id : "",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTokens(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTokens(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDictionaryOfString_String>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDictionaryOfString_String>;
        }));
    }

    protected processTokens(response: HttpResponseBase): Observable<ApiResponseOfDictionaryOfString_String> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDictionaryOfString_String;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes a quick search for policy data, returning partial policy information per result.
     * @param body (optional) The search request to get policy data.
     * @return OK
     */
    search(body?: PolicySearchRequest | undefined): Observable<ApiResponseOfPolicySearchResultsResponse> {
        let url_ = this.baseUrl + "/v1/policy/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPolicySearchResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPolicySearchResultsResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ApiResponseOfPolicySearchResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPolicySearchResultsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for documents that on a policy that match the provided filter criteria.
     * @param body (optional) The document search request.
     * @return OK
     */
    search(body?: DocumentSearchRequest | undefined): Observable<FlagsApiResponseOfDocumentSearchResponse> {
        let url_ = this.baseUrl + "/v1/documents/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearch(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfDocumentSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfDocumentSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlagsApiResponseOfDocumentSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfDocumentSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a Microsoft.AspNetCore.Mvc.FileContentResult from Symetra.Dcx.Components.Models.Immutable.Documents.SourceSystem.P8.
     * @param id (optional) The document id that maps to this document in p8.
     * @param policyToken (optional) The policy token that maps to this document in p8.
     * @return OK
     */
    p8(id?: string | undefined, policyToken?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/documents/p8?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (policyToken === null)
            throw new Error("The parameter 'policyToken' cannot be null.");
        else if (policyToken !== undefined)
            url_ += "policyToken=" + encodeURIComponent("" + policyToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processP8(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processP8(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processP8(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Executes email sending.
     * @param body (optional) The ScheduleA letter request.
     * @return OK
     */
    send(body?: ScheduleAEmailServiceInput | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/email/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSend(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSend(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets addresses for a group id.
     * @return OK
     */
    address(): Observable<ApiResponseOfGroupAddressResponse> {
        let url_ = this.baseUrl + "/v1/group/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddress(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddress(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfGroupAddressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfGroupAddressResponse>;
        }));
    }

    protected processAddress(response: HttpResponseBase): Observable<ApiResponseOfGroupAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfGroupAddressResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets addresses for a group id.
     * @return OK
     */
    contacts(): Observable<ApiResponseOfGroupContactResponse> {
        let url_ = this.baseUrl + "/v1/group/contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processContacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processContacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfGroupContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfGroupContactResponse>;
        }));
    }

    protected processContacts(response: HttpResponseBase): Observable<ApiResponseOfGroupContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfGroupContactResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets member detail for an employee.
     * @param body (optional) The request to retrieve member list.
     * @return OK
     */
    detail(body?: MemberDetailSearchRequest | undefined): Observable<ApiResponseOfMemberDetailSearchResponse> {
        let url_ = this.baseUrl + "/v1/member/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDetail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDetail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberDetailSearchResponse>;
        }));
    }

    protected processDetail(response: HttpResponseBase): Observable<ApiResponseOfMemberDetailSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberDetailSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets member list for a policy.
     * @param body (optional) The request to retrieve member list.
     * @return OK
     */
    list(body?: MemberListSearchRequest | undefined): Observable<ApiResponseOfMemberListSearchResponse> {
        let url_ = this.baseUrl + "/v1/member/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMemberListSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMemberListSearchResponse>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiResponseOfMemberListSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMemberListSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class Oauth2Client extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * An endpoint that returns a cookie for authentication.
     * @param body (optional) The parameters from the client's POST body.
     * @return OK
     */
    token(body?: TokenRequest | undefined): Observable<FlagsApiResponseOfNull> {
        let url_ = this.baseUrl + "/v1/oauth2/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processToken(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processToken(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfNull>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfNull>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<FlagsApiResponseOfNull> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfNull;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logs the user out and redirects them back to the home page.
     * @param clientId The id of the client that initiated logout.
     * @return OK
     */
    logout(clientId: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/oauth2/logout?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * CyberSource bank payment.
     * @param body (optional) Symetra.Benefits.Models.Immutable.CyberSource.PaymentRequest.
     * @return OK
     */
    bank(body?: PaymentRequest | undefined): Observable<ApiResponseOfPaymentResponse> {
        let url_ = this.baseUrl + "/v1/payment/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processBank(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processBank(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentResponse>;
        }));
    }

    protected processBank(response: HttpResponseBase): Observable<ApiResponseOfPaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PremiumClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets calculation information for an invoice.
     * @param body (optional) The searchRequest id to retrieve premium calculation information.
     * @return OK
     */
    calculation(body?: PremiumCalculationSearchRequest | undefined): Observable<ApiResponseOfPremiumCalculationSearchResponse> {
        let url_ = this.baseUrl + "/v1/premium/calculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculation(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculation(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPremiumCalculationSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPremiumCalculationSearchResponse>;
        }));
    }

    protected processCalculation(response: HttpResponseBase): Observable<ApiResponseOfPremiumCalculationSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPremiumCalculationSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets calculation information for an invoice.
     * @param body (optional) The submit request update premium calculation information.
     * @return OK
     */
    submit(body?: PremiumCalculationSubmitRequest | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/premium/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSubmit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSubmit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets premium self-admin details.
     * @param body (optional) Symetra.Benefits.Models.Immutable.Premium.PremiumSelfAdminRequest.
     * @return OK
     */
    selfadmin(body?: PremiumSelfAdminRequest | undefined): Observable<ApiResponseOfPremiumItemsSAResponse> {
        let url_ = this.baseUrl + "/v1/premium/selfadmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSelfadmin(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSelfadmin(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPremiumItemsSAResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPremiumItemsSAResponse>;
        }));
    }

    protected processSelfadmin(response: HttpResponseBase): Observable<ApiResponseOfPremiumItemsSAResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPremiumItemsSAResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SystemClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a hardcoded string. Used to ensure the server is up and handling requests.
     * @return OK
     */
    ping(): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/v1/system/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPing(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPing(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information about the current user.
     * @return OK
     */
    info(): Observable<FlagsApiResponseOfUserInfoResponse> {
        let url_ = this.baseUrl + "/v1/user/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processInfo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInfo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlagsApiResponseOfUserInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlagsApiResponseOfUserInfoResponse>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<FlagsApiResponseOfUserInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlagsApiResponseOfUserInfoResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about the current user.
     * @param body (optional) The user info for the request.
     * @return OK
     */
    accept(body?: UserInfoRequest | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/v1/user/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAccept(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAccept(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** High-level information about all forms response. */
export interface AllFormsResponse {
    /** The Claims forms. */
    claimsForms: FormResponse[] | undefined;
    /** The Custom forms. */
    customForms: FormResponse[] | undefined;
    /** The Employee forms. */
    employeeForms: FormResponse[] | undefined;
    /** The Group Id. */
    groupId: string | undefined;
    /** The Tax forms. */
    taxForms: FormResponse[] | undefined;
}

export interface AmountDetails {
    currencyCode: string;
    totalAmount: number;
}

export interface ApiResponseOfAllFormsResponse {
    /** High-level information about all forms response. */
    data: AllFormsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfBoolean {
    data: boolean;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfCluSearchResponse {
    /** Contract for Claim Loss Unit. */
    data: CluSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfDictionaryOfString_String {
    data: { [key: string]: string; } | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfEOIApplicationsReponse {
    /** Overview of significant dates on the policy, and other high-level policy information. */
    data: EOIApplicationsReponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfGroupAddressResponse {
    data: GroupAddressResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfGroupContactResponse {
    data: GroupContactResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfMemberDetailSearchResponse {
    /** Contract for member detail response. */
    data: MemberDetailSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfMemberListSearchResponse {
    /** Contract for member list. */
    data: MemberListSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPaymentResponse {
    data: PaymentResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPolicyCoveragesResponse {
    /** Coverages associated with a given policy. */
    data: PolicyCoveragesResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPolicySearchResultsResponse {
    /** Response contract for the search endpoint. */
    data: PolicySearchResultsResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPremiumCalculationSearchResponse {
    /** Contract for premium. */
    data: PremiumCalculationSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfPremiumItemsSAResponse {
    /** Premium items. */
    data: PremiumItemsSAResponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfScheduleALetterSearchReponse {
    /** Erisa ScheduleA Letters response to UI. */
    data: ScheduleALetterSearchReponse | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfString {
    data: string | undefined;
    messages: LocalizedMessage[];
}

export interface ApiResponseOfSymetraEmployeeContactResponse {
    /** Representation of Contact. */
    data: SymetraEmployeeContactResponse | undefined;
    messages: LocalizedMessage[];
}

export enum BenefitsModelsImmutableDocumentsDocumentCategory {
    Absence = "Absence",
    All = "All",
    BillingStatements = "BillingStatements",
    Contracts = "Contracts",
    Correspondence = "Correspondence",
    InsufficientCviNotice = "InsufficientCviNotice",
    Life = "Life",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    LTD = "LTD",
    NCE = "NCE",
    Notice = "Notice",
    NYPFL = "NYPFL",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    PFML = "PFML",
    Policies = "Policies",
    RegularPremiumNotices = "RegularPremiumNotices",
    RenewalNotices = "RenewalNotices",
    SB = "SB",
    SBCert = "SBCert",
    SL = "SL",
    Statements = "Statements",
    STD = "STD",
    Unknown = "Unknown",
}

export interface BillingGroupInfo {
    name: string;
    number: string;
}

/** High-level information about a billing response. */
export interface BillingResponse {
    /** The amount the billing belongs to. */
    amount: number;
    /** The amount the billing belongs to for UI. */
    amountUI: string | undefined;
    /** The balance due amount. */
    balanceDue: number;
    /** The bill group name the billing belongs to. */
    billGroupName: string | undefined;
    /** The bill group number the billing belongs to. */
    billGroupNumber: string | undefined;
    /** The billing type the billing belongs to. */
    billingType: string | undefined;
    /** The carried over amount. */
    carriedOverAmount: number;
    /** The due date. */
    dueDate: SymetraDateTimeEnhanced | undefined;
    /** Excel file uri associated with the document. */
    excelFileUri: string | undefined;
    /** Excel mime Type with the document. */
    excelMimeType: BillingResponseExcelMimeType | undefined;
    /** File uri associated with the PDF document. */
    fileUri: string | undefined;
    /** The invoice amount. */
    invoiceAmount: number;
    /** The invoice number the billing belongs to. */
    invoiceNumber: string | undefined;
    /** The invoice period the billing belongs to. */
    invoicePeriod: SpanInfoEnhanced | undefined;
    /** Mime Type with the PDF document. */
    mimeType: BillingResponseMimeType | undefined;
    /** The paid amount. */
    paidAmount: number;
    /** The PolicyId of billing. */
    policyId: string | undefined;
    /** The premium calculation id the billing belongs to. */
    premiumCalculationId: string | undefined;
    /** The premium calculation status the billing belongs to. */
    premiumCalculationStatus: string | undefined;
    /** The Premium Details ID. */
    premiumDetailsId: string | undefined;
    /** The run date the billing belongs to. */
    runDate: SymetraDateTimeEnhanced | undefined;
    /** Statement date of billing. */
    statementDate: SymetraDateTimeEnhanced | undefined;
    /** The status the billing belongs to. */
    status: string | undefined;
    /** The stop date. */
    stopDate: SymetraDateTimeEnhanced | undefined;
}

/** Billing Search Request. */
export interface BillingSearchRequest {
    /** Bill group number to search the billings. */
    billGroupNumber: string | undefined;
    /** Invoice number to search the billings. */
    invoiceNumber: string | undefined;
    /** Invoice period to search the billings. */
    invoicePeriod: SpanInfoEnhanced | undefined;
    /** Page number for the search results. */
    page: number;
    /** Page size for the search results. */
    pageSize: number;
    /** Policy Number to search the billings. */
    policyId: string | undefined;
    /** Run date from to search the billings. */
    runDateFrom: SymetraDateTime | undefined;
    /** Run date to search the billings. */
    runDateTo: SymetraDateTime | undefined;
    /** Billings Status to search the billings. */
    status: string | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

/** Contract for billings. */
export interface BillingSearchResponse {
    /** Policy Number associated with the billing. */
    policyId: string | undefined;
    /** Billings associated with the billing. */
    billings: BillingResponse[] | undefined;
    /** Billings associated with the billing. */
    billingPeriodList: SpanInfoEnhanced[] | undefined;
    /** Billings associated with the billing. */
    billingGroupList: string[] | undefined;
    /** Results per page. */
    resultsPerPage: number;
    /** Results per page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

/** High-level information about a Claim Loss Unit response. */
export interface CluResponse {
    /** Claim Loss Unit name. */
    cluName: string | undefined;
    /** Claim Loss Unit number. */
    cluNumber: string | undefined;
    /** TThe policyId of Claim Loss Unit. */
    policyId: string | undefined;
}

/** Contract for Claim Loss Unit. */
export interface CluSearchResponse {
    /** Group Id associated with the Claim Loss Units. */
    groupId: string | undefined;
    /** Claim Loss Units associated with the Group Id. */
    claimLossUnits: CluResponse[] | undefined;
}

export enum ComponentsModelsImmutableDocumentsDocumentCategory {
    Unknown = "Unknown",
    All = "All",
    Correspondence = "Correspondence",
    Statements = "Statements",
    BillingStatements = "BillingStatements",
    RegularPremiumNotices = "RegularPremiumNotices",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    InsufficientCviNotice = "InsufficientCviNotice",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    Policies = "Policies",
    Contracts = "Contracts",
    RenewalNotices = "RenewalNotices",
    IndexedAccountClosureNotice = "IndexedAccountClosureNotice",
    PremiumStatement = "PremiumStatement",
    SignedLeaveAgreement = "SignedLeaveAgreement",
    PlanDocument = "PlanDocument",
    Contract = "Contract",
    Certificate = "Certificate",
    AdministrativeAgreement = "AdministrativeAgreement",
    ERISA = "ERISA",
    BuyersGuides = "BuyersGuides",
}

/** Representation of a contact details. */
export interface ContactInfo {
    /** Account type of the policy. */
    accountType: string;
    /** Account Manager Name of the policy. */
    accountManagerName: string;
    /** Account Manager Email of the policy. */
    accountManagerEmail: string;
    /** Account Manager Phone of the policy. */
    accountManagerPhone: string;
}

export interface Coverage {
    policyId: string;
    coverageCode: string;
    coverageDesc: string;
    coverageLabel: string;
    coverageBucket: string;
    policyDocsTable: string;
    bucketCode: string;
    documentCategory: string;
    attributes: CoverageAttributes;
}

export interface CoverageAttributes {
    acceleratedDeath: boolean;
    conversion: boolean;
    portability: boolean;
    waiverOfPremium: boolean;
}

/** Premium Coverage Info. */
export interface CoverageItemResponse {
    /** The  coverage type. */
    coverageType: string | undefined;
    /** The class number. */
    classNumber: string | undefined;
    /** The composite rates. */
    compositeRates: CoverageRateResponse | undefined;
    /** The bandedRates. */
    bandedRates: CoverageRateResponse[] | undefined;
}

/** Information about premium rate. */
export interface CoverageRateResponse {
    /** The step band for the premium rate. */
    stepBand: string | undefined;
    /** Rate for the premium rate. */
    rate: number;
    /** Rate basis for the premium rate. */
    rateBasis: string | undefined;
    /** Rate to show in UI for the premium rate. */
    rateForUI: string | undefined;
    /** Head count for the premium rate. */
    headCount: number;
    /** Volume for the premium rate. */
    volume: number;
    /** Premium for the premium rate. */
    premium: number;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export interface DetailCoverageItem {
    benefitAmount: number;
    bucketCode: string | undefined;
    coverageBucket: string | undefined;
    coverageLabel: string | undefined;
    eoiAmount: number;
    guaranteedAmount: number;
    itemId: string;
    itemName: string;
    planCode: string | undefined;
    policyDocsTable: string | undefined;
    premiumTotal: number;
    requestedAmount: number;
}

/** Contract for a single document's metadata from DocViewer. */
export interface DocumentInfoResponse {
    /** The type of document. */
    documentType: string | undefined;
    /** Relative Uri for retrieving the file data. */
    fileUri: string | undefined;
    /** Policy Number associated with the document. */
    policyId: string | undefined;
    /** The date the document was created. */
    documentDate: string | undefined;
    /** The title the document belongs to. */
    documentTitle: string | undefined;
    /** The category the document belongs to. */
    documentCategory: DocumentInfoResponseDocumentCategory | undefined;
    /** The document file extension. */
    fileExtension: string | undefined;
}

/** Represents a search for documents. */
export interface DocumentSearchRequest {
    /** The Policy Ids of document to return. */
    policyIds: string[] | undefined;
    /** The category of document to return. */
    documentCategory: DocumentSearchRequestDocumentCategory;
    /** The direction to sort the results in. */
    sortDirection: SearchSortDirection;
    /** The page of results to return. */
    page: number;
    /** The size of the page of results to return. */
    pageSize: number;
    /** The year of results to return. */
    year: string | undefined;
}

/** A matching page of search results, with metadata needed for pagination. */
export interface DocumentSearchResponse {
    /** The list of documents found in the search. */
    documents: DocumentInfoResponse[] | undefined;
    /** The number of results that were requested per page. */
    resultsPerPage: number;
    /** The total number of pages available. */
    totalPages: number;
    /** The total number of results. */
    totalResults: number;
}

export enum DocumentsContentType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

/** Response of evidence of insurability details. */
export interface EOIApplicant {
    /** The policy Id of the eoi. */
    policyId: string | undefined;
    /** The employee Id of the eoi. */
    employeeId: string | undefined;
    /** The employee name of the eoi. */
    employeeName: string | undefined;
    /** The applicant name of the eoi. */
    applicantName: string | undefined;
    /** The coverage of the eoi. */
    coverage: string | undefined;
    /** The status of the eoi. */
    status: EOIApplicantStatus | undefined;
    /** The total amount of eoi. */
    amount: number;
    /** The submitted date. */
    submittedDate: string | undefined;
    /** The DecisionDate made date. */
    decisionDate: string | undefined;
    /** The Officelocation. */
    officeLocation: string | undefined;
    /** The source system. */
    sourceSystem: string | undefined;
}

/** Overview of significant dates on the policy, and other high-level policy information. */
export interface EOIApplicationsReponse {
    /** List of Applicants. */
    applicants: EOIApplicant[] | undefined;
    /** Results per page. */
    currentPage: number;
    /** Results per page. */
    resultsPerPage: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
}

/** Search request for policies. */
export interface EOIApplicationsRequest {
    /** Filter EOI Applications by the Applicant Name. */
    applicantName: string | undefined;
    /** Filter EOI Applications by the Decision From Date. */
    decisionFromDate: string | undefined;
    /** Filter EOI Applications by the Decision To Date. */
    decisionToDate: string | undefined;
    /** Filter EOI Applications by the Employee Name. */
    employeeName: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Filter Policy ID. */
    policyId: string | undefined;
    /** Filter Policy IDs. */
    policyIds: string[] | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Filter EOI Applications by the Status. */
    status: string[] | undefined;
    /** Filter EOI Applications by the Submitted From Date. */
    submittedFromDate: string | undefined;
    /** Filter EOI Applications by the Submitted To Date. */
    submittedToDate: string | undefined;
}

/** Eoi Statuses. */
export enum EoiStatus {
    Approved = "Approved",
    Declined = "Declined",
    Expired_application = "Expired application",
    Incomplete = "Incomplete",
    In_Process = "In Process",
    EOI_not_needed = "EOI not needed",
    Pending = "Pending",
    Returned_to_applicant = "Returned to applicant",
    Returned_to_policyholder = "Returned to policyholder",
    Unknown = "Unknown",
    Withdrew = "Withdrew",
}

export interface FlagsApiResponseOfBillingSearchResponse {
    flags: IFlag[];
    /** Contract for billings. */
    data: BillingSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfBoolean {
    flags: IFlag[];
    data: boolean;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfDocumentSearchResponse {
    flags: IFlag[];
    /** A matching page of search results, with metadata needed for pagination. */
    data: DocumentSearchResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfNull {
    flags: IFlag[];
    data: Null | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfPolicyOverviewResponse {
    flags: IFlag[];
    /** Overview of significant dates on the policy, and other high-level policy information. */
    data: PolicyOverviewResponse | undefined;
    messages: LocalizedMessage[];
}

export interface FlagsApiResponseOfUserInfoResponse {
    flags: IFlag[];
    /** User information response contract. */
    data: UserInfoResponse | undefined;
    messages: LocalizedMessage[];
}

/** Response of all forms details. */
export interface FormResponse {
    /** The Id of the form. */
    id: string | undefined;
    /** The form flag of the form. */
    formsFlag: FormsFlag;
    /** The name the form. */
    name: string | undefined;
    /** The English form number of the form. */
    englishFormNumber: string | undefined;
    /** The English Url of the form. */
    englishUrl: string | undefined;
    /** The Portability of the form. */
    portability: boolean;
    /** The Included Coverages of the form. */
    includedCoverages: string | undefined;
    /** The Included PlanCodes of the form. */
    includedPlanCodes: string | undefined;
    /** The Included States of the form. */
    includedStates: string | undefined;
    /** The Excluded States of the form. */
    excludedStates: string | undefined;
    /** The Accelerated Death of the form. */
    acceleratedDeath: boolean;
    /** The Waiver Of Premium of the form. */
    waiverOfPremium: boolean;
    /** The Conversion of the form. */
    conversion: boolean;
}

export enum FormsFlag {
    EmployeeForm = "EmployeeForm",
    ClaimsForm = "ClaimsForm",
    TaxForm = "TaxForm",
    CustomerForm = "CustomerForm",
}

export enum Gender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export interface GroupAddressResponse {
    address1: string | undefined;
    address2: string | undefined;
    address3: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

export interface GroupContact {
    displayName: string;
    emails: string[];
    groupContactId: string;
    keyName: string;
    phones: string[];
    primaryContact: string;
}

export interface GroupContactResponse {
    groupContact: GroupContact[] | undefined;
}

export interface GroupInformation {
    name: string;
    number: string;
    id: string;
}

export interface IFlag {
    readonly name: string;
    readonly enabled: boolean;
}

export interface IMessageId {
    readonly value: string;
}

export interface InvoiceInfo {
    period: SpanInfoEnhanced | undefined;
    number: string;
    amount: number;
}

export interface LineItemInfo {
    invoice: InvoiceInfo;
    billingGroup: BillingGroupInfo;
}

export interface LocalizedMessage {
    body: string | undefined;
    id: IMessageId;
    severity: MessageSeverity;
    context: { [key: string]: any; };
}

export interface MemberCoverage {
    classCode: string | undefined;
    coverageId: string | undefined;
    current: boolean;
    effectiveDate: string | undefined;
    items: DetailCoverageItem[];
    sortNames: string[];
    terminationDate: string | undefined;
}

export interface MemberDependent {
    dob: string | undefined;
    employeeId: string | undefined;
    firstName: string | undefined;
    fullName: string | undefined;
    gender: MemberDependentGender | undefined;
    isDisabled: boolean;
    isSmoker: boolean;
    isStudent: boolean;
    lastName: string | undefined;
    maskedSsn: string | undefined;
    middleName: string | undefined;
    relationship: MemberDependentRelationship | undefined;
    status: MemberDependentStatus | undefined;
}

/** Member detail response. */
export interface MemberDetailResponse {
    /** Employee id. */
    employeeId: string | undefined;
    /** Employee id. */
    contractId: string | undefined;
    /** First name. */
    firstName: string | undefined;
    /** Last name. */
    lastName: string | undefined;
    /** Middle name. */
    middleName: string | undefined;
    /** Suffix. */
    suffix: string | undefined;
    /** Date of birth. */
    dob: string | undefined;
    /** Date of birth. */
    gender: MemberDetailResponseGender | undefined;
    /** Member smoker status. */
    smokerStatus: MemberDetailResponseSmokerStatus | undefined;
    /** Member contract status. */
    contractStatus: MemberDetailResponseContractStatus | undefined;
    /** Member masked ssn. */
    maskedSsn: string | undefined;
    /** Job Site Code. */
    jobSiteCode: string | undefined;
    /** Coverage. */
    coverage: MemberCoverage[] | undefined;
    /** Occupation. */
    occupation: string | undefined;
    /** Bill division. */
    billDivision: string | undefined;
    /** Dependents. */
    dependents: MemberDependent[] | undefined;
    /** Salaries. */
    salaries: MemberSalary[] | undefined;
}

/** Member detail search request. */
export interface MemberDetailSearchRequest {
    /** Contract Id to search member detail. */
    contractId: string | undefined;
    /** Individual Id to search member detail. */
    individualId: string | undefined;
}

/** Contract for member detail response. */
export interface MemberDetailSearchResponse {
    /** Member detail response. */
    memberDetail: MemberDetailResponse | undefined;
}

/** Member response. */
export interface MemberInfoResponse {
    /** The applicant name. */
    applicantName: string | undefined;
    /** The billing code. */
    billingCode: string | undefined;
    /** The billing group. */
    billingDivision: string | undefined;
    /** The contract id. */
    contractId: string | undefined;
    /** The coverage. */
    coverage: string | undefined;
    /** The DOB. */
    dob: string | undefined;
    /** The employee id. */
    employeeId: string | undefined;
    /** The employee name. */
    employeeName: string | undefined;
    /** First name. */
    firstName: string | undefined;
    /** Last name. */
    lastName: string | undefined;
    /** Middle name. */
    middleName: string | undefined;
    /** The relationship. */
    relationship: MemberInfoResponseRelationship | undefined;
    /** The Status. */
    status: MemberInfoResponseStatus | undefined;
    /** Suffix. */
    suffix: string | undefined;
}

/** Member list. */
export interface MemberListResponse {
    /** Member list. */
    members: MemberInfoResponse[] | undefined;
    /** Policy id for the member list. */
    policyId: string | undefined;
}

/** Member list search request. */
export interface MemberListSearchRequest {
    /** Filter members by the billing division. */
    billingDivision: string | undefined;
    /** Filter members by the employee name. */
    employeeName: string | undefined;
    /** Group Id to search members. */
    groupId: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Policy number to search members. */
    policyId: string | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Filter members by the Status. */
    status: MemberListSearchRequestStatus | undefined;
}

/** Contract for member list. */
export interface MemberListSearchResponse {
    /** Member list response. */
    memberListResponse: MemberListResponse | undefined;
    /** Billings division. */
    billingDivisionList: string[];
    /** Results per page. */
    resultsPerPage: number;
    /** Current page. */
    currentPage: number;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
}

export interface MemberSalary {
    annualSalary: number;
    endDate: string | undefined;
    salaryId: string | undefined;
    startDate: string | undefined;
}

export enum MemberSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum MemberStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MessageSeverity {
    Info = "Info",
    Warn = "Warn",
    Error = "Error",
}

export interface Null {
}

export interface PaymentInformation {
    accountType: string;
    accountNumber: string;
    routingNumber: string;
}

export interface PaymentRequest {
    amountDetails: AmountDetails | undefined;
    groupInformation: GroupInformation | undefined;
    lineItems: LineItemInfo[] | undefined;
    paymentInformation: PaymentInformation | undefined;
    userInformation: UserInformation | undefined;
}

export interface PaymentResponse {
    groupId: string;
    cyberSourceId: string;
    paymentStatus: string;
    reconciliationId: string;
    transactionId: string;
    submitTimeUtc: string;
}

/** Representation of a payment details. */
export interface Payments {
    /** The policyId to search payment details against the policy. */
    policyId: string;
    /** Optional, Estimated payment amount due for policy. */
    estimatedPaymentAmountDue: number;
    /** Optional, Upcoming payment amount due for policy. */
    upcomingPaymentAmountDue: number;
    /** Due date of the policy. */
    dueDate: string;
    /** Optional, Last payment amount for Policy. */
    lastPaymentAmount: number;
    /** Optional, Policy last payment date. */
    lastPaymentDate: string;
    /** Optional, Policy billing method. */
    billingMethod: string;
}

export enum PersonRelationCode {
    Additional_Writing_Agent = "Additional Writing Agent",
    Annuitant = "Annuitant",
    Assignee = "Assignee",
    Beneficiary = "Beneficiary",
    Contingent_Annuitant = "Contingent Annuitant",
    Coverage_Insured = "Coverage Insured",
    Dependent = "Dependent",
    Insured = "Insured",
    Joint_Annuitant = "Joint Annuitant",
    Joint_insured = "Joint insured",
    Joint_owner = "Joint owner",
    Owner = "Owner",
    Payor = "Payor",
    Primary_Writing_Agent = "Primary Writing Agent",
    Servicing_Agent = "Servicing Agent",
    Spouse = "Spouse",
    Subordinate_Agent = "Subordinate Agent",
    Superior_Agent = "Superior Agent",
    Third_Party_Designee = "Third Party Designee",
}

/** Information about policy billing. */
export interface PolicyBillingGroup {
    /** The Policy Id of billing. */
    groupId: string;
    /** The billing group name of billing. */
    billingGroupName: string;
    /** The billing group code of billing. */
    billingGroupCode: string;
    /** The admin style of billing. */
    adminStyle: string;
}

/** Information about policy coverage. */
export interface PolicyCoverage {
    /** The Policy Id of coverage. */
    policyId: string;
    /** The coverage code of coverage. */
    coverageCode: string;
    /** Description of coverage. */
    coverageDesc: string;
    /** Description of the coverage label. */
    coverageLabel: string;
    /** Description of the coverage bucket. */
    coverageBucket: string;
    /** Description of the coverage for docs table label. */
    policyDocsTable: string;
    /** Description of the bucket code. */
    bucketCode: string;
    /** Coverage attributes. */
    attributes: CoverageAttributes;
}

export interface PolicyCoverages {
    readonly coverages: Coverage[];
    readonly groupId: string;
}

/** Coverages associated with a given policy. */
export interface PolicyCoveragesResponse {
    /** Policy id for the policy. */
    policyCoverages: PolicyCoverages | undefined;
}

/** Representation of a policy details. */
export interface PolicyDetails {
    /** The policy name to hold the name. */
    policyHolder: string;
    /** Policy Id to identify the policy among policies. */
    policyId: string;
    /** Group Id. */
    groupId: string;
    /** Group name. */
    groupName: string;
    /** The effective date of the policy. */
    effectiveDate: string;
    /** The next renewal of the policy. */
    nextRenewalDate: string;
    /** Status of the policy. */
    status: string;
    /** Situs State of the policy. */
    situsState: string;
    /** Anniversary date of the policy holder. */
    anniversaryDate: string;
    /** Symetra.Benefits.Models.Immutable.Policy.Core.CoverageAttributes. */
    attributes: CoverageAttributes;
}

/** Representation of a policy offering. */
export interface PolicyOffering {
    /** Policy Id to identify the policy among offering. */
    policyId: string | undefined;
    /** The effective date of the offering. */
    effectiveDate: string | undefined;
    /** The termination date of the offering. */
    terminationDate: string | undefined;
    /** status of the offering. */
    status: string | undefined;
}

/** Overview of significant dates on the policy, and other high-level policy information. */
export interface PolicyOverviewResponse {
    /** Policy Details for the policy. */
    policyDetails: PolicyDetails | undefined;
    /** Policy Coverages for the policy. */
    policyCoverages: PolicyCoverage[] | undefined;
    /** Policy Billings for the policy. */
    policyBillings: PolicyBillingGroup[] | undefined;
    /** Policy Offerings for the policy. */
    policyOfferings: PolicyOffering[] | undefined;
    /** Contact information for the policy. */
    contactInfo: ContactInfo[] | undefined;
    /** Payment details for the policy. */
    payments: Payments | undefined;
    /** Lad policy. */
    isLad: boolean;
    /** SL policy. */
    isSL: boolean;
    /** The id of the group. */
    groupId: string | undefined;
    /** The group number of the group. */
    groupNumber: string | undefined;
    /** The policy ids. */
    policyIds: string[] | undefined;
    /** Policy token, used to access the policy. */
    policyToken: string | undefined;
}

/** Search request for policies. */
export interface PolicySearchRequest {
    /** The search category enum, such as "owner" or "policyId". */
    category: SearchCategory;
    /** The criteria to search for based on category. */
    criteria: string | undefined;
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

/** A search result with partial policy information. */
export interface PolicySearchResultResponse {
    /** Group number. */
    employerId: string | undefined;
    /** Group number. */
    groupId: string | undefined;
    /** Group name. */
    groupName: string | undefined;
    /** Denotes the policy is in a suspended state. */
    isSuspended: boolean;
    /** The policyholder name. */
    policyholder: string | undefined;
    /** Policy number. */
    policyId: string | undefined;
    /** Policy token, used to access the policy. */
    policyToken: string | undefined;
    /** The relationship of the person on the policy. */
    relationship: PolicySearchResultResponseRelationship | undefined;
}

/** Response contract for the search endpoint. */
export interface PolicySearchResultsResponse {
    /** Results per page. */
    resultsPerPage: number;
    /** List of search results. */
    searchResults: PolicySearchResultResponse[] | undefined;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
}

export interface PolicyholderInfo {
    isAdmin: boolean;
    isClaim: boolean;
    clientIds: string[];
    hasEoi: boolean;
    groupId: string;
}

/** Premium calculation Info. */
export interface PremiumCalculationInfoResponse {
    /** Policy id for the premium calculation. */
    policyId: string;
    /** Invoice number for the premium calculation. */
    invoiceNumber: string;
    /** Coverage items for the premium calculation. */
    coverageItems: CoverageItemResponse[] | undefined;
}

/** Premium search request. */
export interface PremiumCalculationSearchRequest {
    /** Policy number to search the premium calculation. */
    policyId: string | undefined;
    /** Invoice number to search the premium calculation. */
    invoiceNumber: string | undefined;
}

/** Contract for premium. */
export interface PremiumCalculationSearchResponse {
    /** Premium calculation info for the invoice. */
    premiumCalculationInfo: PremiumCalculationInfoResponse | undefined;
}

/** Premium calculation update request. */
export interface PremiumCalculationSubmitRequest {
    /** Group id to update premium calculation. */
    groupId: string | undefined;
    /** Premium Id to update premium calculation. */
    premiumId: string | undefined;
    /** The Group Name. */
    groupName: string | undefined;
    /** Group number. */
    groupNumber: string | undefined;
    /** Bill group name. */
    billGroupName: string | undefined;
    /** Bill group number. */
    billGroupNumber: string | undefined;
    /** Invoice period of updated premium calc.. */
    invoicePeriod: SpanInfoEnhanced;
    /** Invoice number. */
    invoiceNumber: string | undefined;
    /** Total amount of updated premium calculation. */
    totalAmount: number;
    /** Premium line items to be updated. */
    premiumItems: PremiumItemResponse[] | undefined;
}

/** Premium line item info. */
export interface PremiumItemResponse {
    /** The premium line item Id. */
    id: string | undefined;
    /** The line item volume. */
    volume: number;
    /** The line item units. */
    units: number;
    /** Premium submit item premiumTotal. */
    premiumTotal: number;
    /** Premium submit item PremiumRate01. */
    premiumRate01: number;
    /** CoverageType. */
    coverageType: string | undefined;
    /** Class. */
    class: number;
}

/** Premium items. */
export interface PremiumItemsSAResponse {
    /** Group ID. */
    groupId: string;
    /** Premium ID. */
    premiumId: string;
    /** Symetra.Benefits.Models.Immutable.DateTimeInfo.SpanInfo. */
    invoicePeriod: SpanInfo;
    /** Submitted by. */
    submittedBy: string;
    /** Submitted date. */
    submittedDate: string;
    /** SA comment. */
    saComment: string;
    /** List of Symetra.Benefits.Models.Immutable.Premium.PremiumSelfAdminInfoItem. */
    premiums: PremiumSelfAdminInfoItem[] | undefined;
}

export interface PremiumSelfAdminInfoItem {
    id: string;
    coverageLabel: string | undefined;
    policyClassCode: string | undefined;
    premiumRate01: number;
    premiumTotal: number;
    productComponentCode: string;
    saComment: string | undefined;
    units: number;
    updatedBy: string | undefined;
    updatedDate: SymetraDateTime | undefined;
    volume: number;
}

export interface PremiumSelfAdminRequest {
    groupId: string;
    premiumId: string;
    invoicePeriod: SpanInfoEnhanced;
}

export enum Relationship {
    Child = "Child",
    Former_Spouse = "Former Spouse",
    Self = "Self",
    Spouse = "Spouse",
    Unknown = "Unknown",
}

export interface ScheduleAEmailServiceInput {
    policyId: string;
    policyName: string;
    requestorName: string | undefined;
    requestorUserName: string | undefined;
    requestorEmail: string | undefined;
    dateFrom: string;
    dateTo: string;
}

/** High-level information about a scheduleA letter response. */
export interface ScheduleALetterReponse {
    /** Activity date of scheduleA letter. */
    activityDate: string | undefined;
    /** File id associated with the PDF document. */
    fileId: string | undefined;
    /** File uri associated with the PDF document. */
    fileUri: string | undefined;
    /** Mime Type with the PDF document. */
    mimeType: ScheduleALetterReponseMimeType | undefined;
    /** Plan's year of scheduleA letter. */
    planYear: string | undefined;
    /** The Policy Id of scheduleA letter. */
    policyId: string | undefined;
    /** Statement date of scheduleA letter. */
    statementDate: string | undefined;
}

/** Erisa ScheduleA Letters response to UI. */
export interface ScheduleALetterSearchReponse {
    /** Results per page. */
    currentPage: number;
    /** List of scheduleA letters. */
    letters: ScheduleALetterReponse[] | undefined;
    /** Policy Number associated with the scheduleA letters. */
    policyId: string | undefined;
    /** Policy Numbers associated with the scheduleA letters. */
    policyIds: string[] | undefined;
    /** Results per page. */
    resultsPerPage: number;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
    /** Total pages of results. */
    totalPages: number;
    /** Total number of results across all pages. */
    totalResults: number;
}

/** Search request for scheduleA letter. */
export interface ScheduleALetterSearchRequest {
    /** The page number indicator for pagination. */
    page: number;
    /** The size of each page. */
    pageSize: number;
    /** Filter Policy ID. */
    policyId: string | undefined;
    /** Filter Policy IDs. */
    policyIds: string[] | undefined;
    /** The direction to sort the search results by (Ascending or Descending). */
    sortDirection: SearchSortDirection;
    /** The field to sort the search results by. */
    sortField: SearchSortField;
}

export enum SearchCategory {
    Owner = "Owner",
    Insured = "Insured",
    GroupId = "GroupId",
    Unspecified = "Unspecified",
}

export enum SearchSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum SearchSortField {
    Unspecified = "Unspecified",
    Name = "Name",
    PolicyId = "PolicyId",
    Role = "Role",
    EmployeeName = "EmployeeName",
    ApplicantName = "ApplicantName",
    SubmittedFromDate = "SubmittedFromDate",
    SubmittedToDate = "SubmittedToDate",
    DecisionFromDate = "DecisionFromDate",
    DecisionToDate = "DecisionToDate",
    Status = "Status",
    RunDate = "RunDate",
    InvoiceNumber = "InvoiceNumber",
    BillGroupName = "BillGroupName",
    Invoice = "Invoice",
    BillGroup = "BillGroup",
    Amount = "Amount",
    Coverage = "Coverage",
    StatementDate = "StatementDate",
    BillingDivision = "BillingDivision",
    LastName = "LastName",
    FirstName = "FirstName",
}

export interface SpanInfo {
    begin: SymetraDateTime;
    end: SymetraDateTime;
}

export interface SpanInfoEnhanced {
    begin: SymetraDateTimeEnhanced;
    end: SymetraDateTimeEnhanced;
}

export interface SymEmployeeInfo {
    isSuper: boolean;
    isClaims: boolean;
    isSubmit: boolean;
    isBasic: boolean;
}

export interface SymetraDateTime {
    readonly day: number;
    readonly dayOfWeek: DayOfWeek;
    readonly month: number;
    unixMilliseconds: number;
    readonly year: number;
}

export interface SymetraDateTimeEnhanced {
    dateTime: SymetraDateTime | undefined;
    unixMilliseconds: number;
}

/** Representation of Contact. */
export interface SymetraEmployeeContactResponse {
    /** The user id of sym employee. */
    userName: string | undefined;
    /** The display name of sym employee. */
    displayName: string | undefined;
    /** The first name of sym employee. */
    firstName: string | undefined;
    /** The last name of sym employee. */
    lastName: string | undefined;
    /** The phone of sym employee. */
    phone: string | undefined;
    /** The email of sym employee. */
    email: string | undefined;
}

export interface TermConditionConsentInfo {
    termsConditionsAccepted: boolean;
    electronicConsentAccepted: boolean;
    hasRecords: boolean;
}

export interface TokenRequest {
    authorizationCode: string;
    clientId: string;
    redirectUrl: string;
}

/** Identity User Info request contract. */
export interface UserInfoRequest {
    /** The terms and conditions accepted. */
    termsConditionsAccepted: boolean;
    /** The electronic consent accepted. */
    electronicConsentAccepted: boolean;
}

/** User information response contract. */
export interface UserInfoResponse {
    /** Current user's email. */
    email: string | undefined;
    /** Current user's Given name. */
    firstName: string | undefined;
    /** Current user's full name. */
    fullName: string | undefined;
    /** Current user's Surname name. */
    lastName: string | undefined;
    /** Current user's phone number. */
    phoneNumber: string | undefined;
    /** User info. */
    policyholderInfo: PolicyholderInfo | undefined;
    /** User classification. */
    symClass: string | undefined;
    /** User info. */
    symEmployeeInfo: SymEmployeeInfo | undefined;
    /** User's id. */
    userId: string | undefined;
    /** Current user's user name. */
    userName: string | undefined;
    /** Current user's term, condition and consent info. */
    termConditionConsent: TermConditionConsentInfo | undefined;
}

export interface UserInformation {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    userName: string;
}

export enum BillingResponseExcelMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export enum BillingResponseMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export enum DocumentInfoResponseDocumentCategory {
    Absence = "Absence",
    All = "All",
    BillingStatements = "BillingStatements",
    Contracts = "Contracts",
    Correspondence = "Correspondence",
    InsufficientCviNotice = "InsufficientCviNotice",
    Life = "Life",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    LTD = "LTD",
    NCE = "NCE",
    Notice = "Notice",
    NYPFL = "NYPFL",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    PFML = "PFML",
    Policies = "Policies",
    RegularPremiumNotices = "RegularPremiumNotices",
    RenewalNotices = "RenewalNotices",
    SB = "SB",
    SBCert = "SBCert",
    SL = "SL",
    Statements = "Statements",
    STD = "STD",
    Unknown = "Unknown",
}

export enum DocumentSearchRequestDocumentCategory {
    Unknown = "Unknown",
    All = "All",
    Correspondence = "Correspondence",
    Statements = "Statements",
    BillingStatements = "BillingStatements",
    RegularPremiumNotices = "RegularPremiumNotices",
    PastDuePremiumNotices = "PastDuePremiumNotices",
    InsufficientCviNotice = "InsufficientCviNotice",
    LoanInterestNotices = "LoanInterestNotices",
    LoanPremiumComboNotices = "LoanPremiumComboNotices",
    Policies = "Policies",
    Contracts = "Contracts",
    RenewalNotices = "RenewalNotices",
    IndexedAccountClosureNotice = "IndexedAccountClosureNotice",
    PremiumStatement = "PremiumStatement",
    SignedLeaveAgreement = "SignedLeaveAgreement",
    PlanDocument = "PlanDocument",
    Contract = "Contract",
    Certificate = "Certificate",
    AdministrativeAgreement = "AdministrativeAgreement",
    ERISA = "ERISA",
    BuyersGuides = "BuyersGuides",
}

export enum EOIApplicantStatus {
    Approved = "Approved",
    Declined = "Declined",
    Expired_application = "Expired application",
    Incomplete = "Incomplete",
    In_Process = "In Process",
    EOI_not_needed = "EOI not needed",
    Pending = "Pending",
    Returned_to_applicant = "Returned to applicant",
    Returned_to_policyholder = "Returned to policyholder",
    Unknown = "Unknown",
    Withdrew = "Withdrew",
}

export enum MemberDependentGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum MemberDependentRelationship {
    Child = "Child",
    Former_Spouse = "Former Spouse",
    Self = "Self",
    Spouse = "Spouse",
    Unknown = "Unknown",
}

export enum MemberDependentStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberDetailResponseGender {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Unknown = "Unknown",
}

export enum MemberDetailResponseSmokerStatus {
    NonSmoker = "NonSmoker",
    Smoker = "Smoker",
    Unknown = "Unknown",
}

export enum MemberDetailResponseContractStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberInfoResponseRelationship {
    Child = "Child",
    Former_Spouse = "Former Spouse",
    Self = "Self",
    Spouse = "Spouse",
    Unknown = "Unknown",
}

export enum MemberInfoResponseStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum MemberListSearchRequestStatus {
    Active = "Active",
    Calculated = "Calculated",
    Deceased = "Deceased",
    Draft = "Draft",
    Planned_termination = "Planned termination",
    Inactive = "Inactive",
    Leave = "Leave",
    Pensing = "Pensing",
    Processed = "Processed",
    Retired = "Retired",
    Returned_to_Work = "Returned to Work",
    Terminated = "Terminated",
    Unknown = "Unknown",
}

export enum PolicySearchResultResponseRelationship {
    Additional_Writing_Agent = "Additional Writing Agent",
    Annuitant = "Annuitant",
    Assignee = "Assignee",
    Beneficiary = "Beneficiary",
    Contingent_Annuitant = "Contingent Annuitant",
    Coverage_Insured = "Coverage Insured",
    Dependent = "Dependent",
    Insured = "Insured",
    Joint_Annuitant = "Joint Annuitant",
    Joint_insured = "Joint insured",
    Joint_owner = "Joint owner",
    Owner = "Owner",
    Payor = "Payor",
    Primary_Writing_Agent = "Primary Writing Agent",
    Servicing_Agent = "Servicing Agent",
    Spouse = "Spouse",
    Subordinate_Agent = "Subordinate Agent",
    Superior_Agent = "Superior Agent",
    Third_Party_Designee = "Third Party Designee",
}

export enum ScheduleALetterReponseMimeType {
    Text = "Text",
    Json = "Json",
    Xml = "Xml",
    Pdf = "Pdf",
    FormUrlEncoded = "FormUrlEncoded",
    Jpeg = "Jpeg",
    Tiff = "Tiff",
    Bmp = "Bmp",
    Png = "Png",
    Html = "Html",
    WordDoc = "WordDoc",
    ExcelDoc = "ExcelDoc",
    Csv = "Csv",
    Gif = "Gif",
    OctetStreamPdf = "OctetStreamPdf",
    RichTextFormat = "RichTextFormat",
    OldExcelDoc = "OldExcelDoc",
    ExcelTemplate = "ExcelTemplate",
    ExcelDocWithMacros = "ExcelDocWithMacros",
    ExcelTemplateWithMacros = "ExcelTemplateWithMacros",
    ExcelAddinWithMacros = "ExcelAddinWithMacros",
    ExcelBinaryWithMacros = "ExcelBinaryWithMacros",
    OldPowerPoint = "OldPowerPoint",
    PowerPointDoc = "PowerPointDoc",
    PowerPointTemplate = "PowerPointTemplate",
    PowerPointSlideshow = "PowerPointSlideshow",
    PowerPointAddinWithMacros = "PowerPointAddinWithMacros",
    PowerPointFileWithMacros = "PowerPointFileWithMacros",
    PowerPointSlideshowWithMacros = "PowerPointSlideshowWithMacros",
    OldProject = "OldProject",
    OldVisio = "OldVisio",
    OldWord = "OldWord",
    WordTemplate = "WordTemplate",
    WordDocWithMacros = "WordDocWithMacros",
    WordTemplateWithMacros = "WordTemplateWithMacros",
    Framemaker = "Framemaker",
    MicrosoftDocumentImaging = "MicrosoftDocumentImaging",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// :  Do NOT delete this file!  It is required for the 'nswag' utility to work properly.
// :  This file is used to extend the generated client with custom code.

/* istanbul ignore file */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars